module.exports = __webpack_public_path__ + "img/08.7ff4997a.png";